import React from 'react'
import MuiPagination from '@mui/material/Pagination'
import styled from 'styled-components'

type props = {
  page: number
  pageCount: number
  size?: 'small' | 'medium' | 'large'
  onPageChange: (number) => void
  className?: string
}

const Pagination = ({ page = 1, pageCount = 0, size = 'medium', onPageChange, className = '' }: props) => {
  return (
    <S.Container className={className}>
      <MuiPagination
        size={size}
        count={pageCount}
        onChange={(_event, page) => onPageChange(page)}
        page={page}
        shape="circular"
      />
    </S.Container>
  )
}

export default Pagination

const S = {
  Container: styled.div`
    display: inline-block;
    float: right;
    white-space: nowrap;
  `
}
